// src/chatbot/config.js
import {createChatBotMessage} from 'react-chatbot-kit';
import Avatar from "./Avatar";
import {ReactComponent as RobotIcon} from "../../assets/img/robot-svgrepo-com.svg"; // Importa el SVG como componente
import {ReactComponent as UserIcon} from "../../assets/img/person_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg";
import InstalacionesMessage from "./widgets/InstalacionesMessage";
import WidgetOpcionesConfirmar from "./widgets/venta/WidgetOpcionesConfirmar";
import WidgetResumenVenta from "./widgets/venta/WidgetResumenVenta"; // Importa el SVG como componente
import PromocionesMessage from "./widgets/PromocionesMessage"; 
import WidgetOpcionesValidacionCliente from "./widgets/WidgetOpcionesValidacionCliente";
import WidgetOpcionesInicio from "./widgets/WidgetOpcionesInicio";
import WidgetSeleccionValidacion from './widgets/WidgetSeleccionValidacion';
import WidgetOpcionesValidacionRapida from './widgets/WidgetOpcionesValidacionRapida';
import WidgetSeleccionFecha from "./widgets/venta/WidgetSeleccionFecha";
import WidgetOpcionesConfirmarSeguirVenta from "./widgets/venta/WidgetOpcionesConfirmarSeguirVenta";
import WidgetSubirArchivo from "./widgets/venta/WidgetSubirArchivo";
import WidgetClienteCoberturaMessage from "./widgets/WidgetClienteCoberturaMenssage";

const botName = "Fabrizzio";

const config = {
    botName: botName,
    initialMessages: [
        createChatBotMessage(`¡Hola! Soy ${botName}, ¿en qué puedo ayudarte?`, {
            widget: "opcionesInicio"
        }),
    ],
    customStyles: {
        botMessageBox: {
            backgroundColor: "#d90e75",
        },
        chatButton: {
            backgroundColor: "#d90e75",
        },
    },
    customComponents: {
        botAvatar: () => (
            <Avatar
                icon={RobotIcon}
                backgroundColor="#00bcb4"
                fillColor="#fff"
                marginRight={15}
                size={35}
                alt={`${botName} Avatar`}
            />
        ),
        userAvatar: () => (
            <Avatar
                icon={UserIcon}
                backgroundColor="#ec6907"
                fillColor="#fff"
                marginLeft={15}
                size={35}
                alt={`${botName} Avatar`}
            />
        ),
    },
    widgets: [
        {
            widgetName: "opcionesInicio",
            widgetFunc: (props) => <WidgetOpcionesInicio {...props} />,
            mapStateToProps: ["messages"], // Si es necesario, puedes quitar esto y probar
        },
        {
            widgetName: "opcionesValidacionRapida",
            widgetFunc: (props) => <WidgetOpcionesValidacionRapida {...props} />,
        },

        {
            widgetName: "seleccionValidacion",
            widgetFunc: (props) => <WidgetSeleccionValidacion {...props} />,
          },
    
        {
            widgetName: "opcionesValidacionCliente", // Nuevo widget para elegir método de validación del cliente
            widgetFunc: (props) => <WidgetOpcionesValidacionCliente {...props} />,
        },
        
        {
            widgetName: "instalacionesMensaje",
            widgetFunc: (props) => <InstalacionesMessage {...props} />,
             mapStateToProps: ["instalaciones"],
        },
        {
            widgetName: "promocionesMessage", // Nuevo widget para promociones
            widgetFunc: (props) => <PromocionesMessage {...props} />,
            mapStateToProps: [], // Puedes mapear propiedades según lo necesites
        },
        {
            widgetName: "opcionesConfirmar",
            widgetFunc: (props) => <WidgetOpcionesConfirmar {...props} />,
        },
        {
            widgetName: "resumenVenta",
            widgetFunc: (props) => <WidgetResumenVenta {...props} />,
        },
        {
            widgetName: "widgetSeleccionFecha",
            widgetFunc: (props) => <WidgetSeleccionFecha {...props} />,
        },
        {
            widgetName: "widgetOpcionesConfirmarSeguirVenta",
            widgetFunc: (props) => <WidgetOpcionesConfirmarSeguirVenta {...props} />,
        },
        {
            widgetName: "widgetSubirArchivo",
            widgetFunc: (props) => <WidgetSubirArchivo {...props} />,
        },
        {
            widgetName: "opcionesValidacionCobertura",
            widgetFunc: (props) => <WidgetClienteCoberturaMessage {...props} />,
        },

    ],
};

export default config;
